export default "__VITE_PUBLIC_ASSET__4e174b7c__"